import { render, staticRenderFns } from "./ChangeLanguageModal.vue?vue&type=template&id=820340da&"
import script from "./ChangeLanguageModal.vue?vue&type=script&lang=js&"
export * from "./ChangeLanguageModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLanguageModal.vue?vue&type=style&index=0&id=820340da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports